import React, { useCallback, useEffect, useState } from "react";
import { ReactComponent as SquareArrow } from "../../../../icons/square_arrow.svg";
import { X, ChevronLeft } from "lucide-react";
import { RuvnlTitle } from "../../components";
import { TabSwitcher } from "../../Raj_Dashboard";

import Hamburger from "../../../../components/Hamburger";
import Tooltip from "../../../../components/tooltip";
import SimulationModHeader from "../ModSimulation/SimulationModHeader";
import { useDispatch, useSelector } from "react-redux";
import { ModDemoSelectedDate } from "../../../../store/state/ModDemo/ModDate";
import { setModDemoSession } from "../../../../store/state/ModDemo/ModSession";
import { setModDemoSessionToken } from "../../../../store/state/ModDemo/ModSessionToken";
import { Download } from "lucide-react";
import {
  fetchLgbrGetData,
  fetchLgbrTableData,
  fetchModDemoArchive,
  ModActivateSession,
} from "../../../../Rest_api/DemoRestApi";
import { SearchBox } from "../../../../components/Search";
import { useMeritEngineNavigation } from "../useMeritEngineNavigation";
import loader from "../../../../components/recharts/loader.gif";
import { ErrorPopup } from "../../../../components/ErrorHandling";
import { ChevronUp, ChevronDown } from "lucide-react";
import LgbrTable from "../LGBR/LgbrIndex";
import Modal from "./Modal";

const DataTabs = ["Active", "Deactive"];
type DrillDownType =
  | "total_generation"
  | "total_must_run"
  | "total_available"
  | null;

export default function ModArchive() {
  const HeaderCell: React.FC<{ title: React.ReactNode }> = ({ title }) => (
    <th className="py-3 text-[14px] px-4 text-center font-medium text-[#F1935C] whitespace-nowrap">
      {title}
    </th>
  );
  const HeaderCell2: React.FC<{ title: React.ReactNode }> = ({ title }) => (
    <th className="py-3 text-[14px] px-4 text-center font-medium text-[#34656D] !bg-[#F7FAFF] whitespace-nowrap">
      {title}
    </th>
  );

  const [ArchiveData, setArchiveData] = useState<any[]>([]);
  const [FilterArchiveData, setFilterArchiveData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [loadingLgbr, setLoadingLgbr] = useState(false);
  const [loadingLgbrData, setLoadingLgbrData] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [expandedRow, setExpandedRow] = useState<number | null>(null);
  const [drillDownView, setDrillDownView] = useState<DrillDownType>(null);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<number | null>(null);
  const [selectedSessionToken, setSelectedSessionToken] = useState<any>();
  const { navigateToPage } = useMeritEngineNavigation();
  const preSelectedDate = useSelector(
    (state: any) => state.modDemoDate.selectedDate
  );
  const modSelectedSession = useSelector(
    (state: any) => state.modDemoSession.modSession
  );

  const [isModalOpen, setModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(DataTabs[0]);
  const [detailedData, setDetailedData] = useState<any[]>([]);
  const dispatch = useDispatch();
  const [uniquecreatedDate, setUniqueCreatedDate] = useState<any[]>([]);
  const [selectedCreatedDate, setSelectedCreatedDate] = useState<any[]>([]);
  const [uniqueTargetDate, setUniqueTargetDate] = useState<any[]>([]);
  const [selectedTargetDate, setSelectedTargetDate] = useState<any[]>([]);
  const [filterLgbrData, setFilterLgbrData] = useState<any[]>([]);
  const [filterGeneratorDate, setFilterGeneratorDate] = useState<string>();
  const [filterGeneratorSession, setFilterGeneratorSession] =
    useState<number>();
  const [sortBy, setSortBy] = useState<string>("generator_name");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");
  const toggleRow = (index: number) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  // Get the current stage index
  const getCurrentStageIndex = (stage: string) => {
    const stages = ["LOAD", "GENERATION", "MOD", "BID"];
    const stageUpper = stage.trim().toUpperCase();
    return stages.indexOf(stageUpper);
  };

  // Check if a stage is completed, active, or inactive
  const getStageStatus = (currentStage: string, checkStage: string) => {
    const stages = ["LOAD", "GENERATION", "MOD", "BID"];
    const currentIndex = getCurrentStageIndex(currentStage);
    const checkIndex = stages.indexOf(checkStage.toUpperCase());

    if (currentIndex === -1) return "inactive";

    if (checkIndex < currentIndex) {
      return "completed"; // Previous stages are completed
    } else if (checkIndex === currentIndex) {
      return "active"; // Current stage is active
    } else {
      return "inactive"; // Future stages are inactive
    }
  };

  const getStageColor = (status: string) => {
    switch (status) {
      case "completed":
        return "bg-[#F1935C]"; // Orange filled for completed
      case "active":
        return "bg-[#F1935C]"; // Orange filled for active
      case "inactive":
        return "bg-gray-200 border border-gray-300"; // Gray for inactive
      default:
        return "bg-gray-200 border border-gray-300";
    }
  };

  const getStageIcon = (status: string) => {
    switch (status) {
      case "completed":
        return "✓"; // Checkmark for completed
      case "active":
        return "●"; // Dot for active
      case "inactive":
        return null; // Empty for inactive
      default:
        return null;
    }
  };

  const getStageIconColor = (status: string) => {
    return status === "completed" || status === "active"
      ? "text-white"
      : "text-gray-400";
  };

  function handleSort(field: string): void {
    if (sortBy === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(field);
      setSortOrder("asc");
    }
    setArchiveData((prevData) => {
      const sorted = [...prevData].sort((a, b) => {
        let aValue = (a as any)[field];
        let bValue = (b as any)[field];
        if (!isNaN(Number(aValue)) && !isNaN(Number(bValue))) {
          aValue = Number(aValue);
          bValue = Number(bValue);
        }
        if (aValue < bValue) return sortOrder === "asc" ? -1 : 1;
        if (aValue > bValue) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });
      return sorted;
    });
  }

  const handleFetchData = useCallback(async () => {
    if (!preSelectedDate || !modSelectedSession) return;

    try {
      setLoading(true);
      const res = await fetchModDemoArchive(
        preSelectedDate,
        modSelectedSession
      );
      setArchiveData(res);
      setUniqueCreatedDate(
        Array.from(
          new Set(res.map((item: { created_date: any }) => item.created_date))
        )
      );
      setUniqueTargetDate(
        Array.from(new Set(res.map((item: { date: any }) => item.date)))
      );
    } catch (error) {
      console.error("Error fetching archive data:", error);
      setError("Error fetching archive data");
      setError("Error fetching archive data");
    } finally {
      setLoading(false);
    }
  }, [modSelectedSession, preSelectedDate]);

  useEffect(() => {
    let filterData = ArchiveData;

    if (selectedCreatedDate.length > 0) {
      const types = selectedCreatedDate.map((t: any) => t.value ?? t);
      filterData = filterData.filter((row) => types.includes(row.created_date));
    }
    if (selectedTargetDate.length > 0) {
      const types = selectedTargetDate.map((t: any) => t.value ?? t);
      filterData = filterData.filter((row) => types.includes(row.date));
    }
    setFilterArchiveData(filterData);
  }, [ArchiveData, selectedCreatedDate, selectedTargetDate]);

  useEffect(() => {
    handleFetchData();
  }, [handleFetchData]);

  const handleLgbrDataClick = async (date: string, session: number) => {
    try {
      setLoadingLgbr(true);

      const resLgbr = await fetchLgbrTableData(date, session);
      setFilterGeneratorDate(resLgbr.date);
      setFilterGeneratorSession(resLgbr.session);
      setFilterLgbrData(resLgbr.data);
    } catch (error) {
      setError("Failed to fetch LGBR data");
    } finally {
      setLoadingLgbr(false);
    }
  };
  const GotoActiveSession = async (
    stage: string,
    date: string,
    session: number,
    session_token: number
  ) => {
    dispatch(ModDemoSelectedDate(date));
    dispatch(setModDemoSession(session));
    dispatch(setModDemoSessionToken(session_token));
    await ModActivateSession(session);
    sessionStorage.removeItem("TabVisited_Demo");
    if (stage) {
      if (stage === "LOAD") {
        navigateToPage("load-price");
      } else if (stage === "GENERATION") {
        navigateToPage("resources");
      } else if (stage === "MOD") {
        navigateToPage("merit-order-dispatch");
      } else if (stage === "BID") {
        navigateToPage("bid");
      }
    } else {
      setError("Error in continue to previous Session");
      setError("Error in continue to previous Session");
    }
  };
  const getColumnTitle = () => {
    switch (drillDownView) {
      case "total_generation":
        return "Total Capacity (MW)";
      case "total_must_run":
        return "Must Run (MW)";
      case "total_available":
        return "Surrendable Power (MW)";
      default:
        return "";
    }
  };
  const handleColumnClick = useCallback(
    async (type: DrillDownType, timeSlot: number) => {
      const view = type;
      const slot = timeSlot;
      setSelectedTimeSlot(slot);
      setDrillDownView(view);
      if (
        !view ||
        slot === null ||
        !filterGeneratorDate ||
        !filterGeneratorSession
      ) {
        setDetailedData([]);
        return;
      }

      try {
        setLoadingLgbrData(true);

        const res = await fetchLgbrGetData(
          view,
          slot,
          filterGeneratorDate,
          filterGeneratorSession
        );

        setDetailedData(res?.data || res || []);
      } catch (error) {
        console.error("Error fetching detailed data:", error);
        setError("An error occurred while fetching detailed data.");
        setDetailedData([]);
      } finally {
        setLoadingLgbrData(false);
      }
    },
    [filterGeneratorDate, filterGeneratorSession]
  );
 
  return (
    <>
      <div className="w-full">
        <div className="dashboard-header flex items-center justify-between px-4">
          <div className="flex items-start w-8">
            <Hamburger />
            {/* <div className="ms-5">
              <TabSwitcher />
            </div> */}
            <div>
              <h5 className="text-[18px] text-[#6F6D7C] ms-5 font-medium">
                MeritEngine
              </h5>
            </div>
          </div>
          <div className="flex-1 flex justify-center ">
            <RuvnlTitle />
          </div>
        </div>
        <div className="h-[calc(-73px+100vh)] p-4">
          <div className="w-full h-full flex flex-col gap-4">
            <SimulationModHeader title={"Archive"} tabsShow={false} />

            <div
              className="gas-chart-container"
              style={{ height: "calc(-92px + 100vh)" }}
            >
              <div className="flex justify-between items-center mb-2 border-b border-[#DFEAF2] pb-2">
                <div className="flex items-center gap-3">
                  <SearchBox
                    options={uniqueTargetDate.map((item) => ({
                      value: item,
                      label: item,
                    }))}
                    isMany={true}
                    placeholder="Target Date"
                    selectedOptions={selectedTargetDate}
                    onChange={setSelectedTargetDate}
                  />
                  <SearchBox
                    options={uniquecreatedDate.map((item) => ({
                      value: item,
                      label: item,
                    }))}
                    isMany={true}
                    placeholder="Creation Date"
                    selectedOptions={selectedCreatedDate}
                    onChange={setSelectedCreatedDate}
                  />
                </div>

                <div className="flex gap-x-6 justify-end">
                  {/* <button
                    // onClick={downloadTable}
                    className="flex items-center gap-2 p-2 text-sm rounded-xl bg-[#FFFAF6] text-[#F1935C] font-medium border border-[#F1935C]"
                  >
                    <span>Download Data</span>
                    <Download className="w-5 h-5" />
                  </button> */}
                </div>
              </div>
              <div
                className="overflow-auto capitalize"
                style={{ maxHeight: "calc(100vh - 220px)" }}
              >
                {loading ? (
                  <div className="h-full w-full bg-white flex items-center justify-center">
                    <img
                      src={loader}
                      width={200}
                      alt="loader"
                      className="block mt-[5rem]"
                    />
                  </div>
                ) : (
                  <>
                    {FilterArchiveData.length === 0 ? (
                      <>
                        <div className="flex items-center justify-center overflow-auto capitalize rounded-lg w-full h-full">
                          <h1 className="chartHeading !text-base text-center !font-medium w-100">
                            No Archive Data Available...
                          </h1>
                        </div>
                      </>
                    ) : (
                      <>
                        <table id="my-table_load" className="w-full">
                          <thead className="sticky top-0 z-10 bg-white">
                            <tr className="text-sm border-gray-200">
                              <th className="py-3 text-[14px] px-4 text-left font-medium text-[#F1935C] w-12"></th>
                              <HeaderCell
                                title={
                                  <span className="cursor-pointer select-none flex items-center justify-center gap-1">
                                    Title
                                  </span>
                                }
                              />
                              <HeaderCell
                                title={
                                  <span className="cursor-pointer select-none flex items-center justify-center gap-1">
                                    Session Id
                                  </span>
                                }
                              />
                              <HeaderCell
                                title={
                                  <span
                                    className="cursor-pointer select-none flex items-center justify-center gap-1"
                                    onClick={() => handleSort("date")}
                                  >
                                    Target Date
                                    {sortBy === "date" &&
                                      (sortOrder === "asc" ? "▲" : "▼")}
                                  </span>
                                }
                              />
                              <HeaderCell
                                title={
                                  <span
                                    className="cursor-pointer select-none flex items-center justify-center gap-1"
                                    onClick={() => handleSort("created_date")}
                                  >
                                    Creation Date
                                    {sortBy === "created_date" &&
                                      (sortOrder === "asc" ? "▲" : "▼")}
                                  </span>
                                }
                              />
                              <HeaderCell
                                title={
                                  <span className="cursor-pointer select-none flex items-center justify-center gap-1">
                                    Creation Time
                                  </span>
                                }
                              />
                              <HeaderCell
                                title={
                                  <span className="cursor-pointer select-none flex items-center justify-center gap-1">
                                    Stage
                                  </span>
                                }
                              />
                              <HeaderCell
                                title={
                                  <span className="cursor-pointer select-none flex items-center justify-center gap-1">
                                    Status
                                  </span>
                                }
                              />
                            </tr>
                          </thead>
                          <tbody className="text-[#8C8A96] font-normal text-[13px]">
                            {FilterArchiveData.map((item, idx) => (
                              <React.Fragment key={idx}>
                                <tr
                                  className={`border-b border-gray-50 hover:bg-gray-50 cursor-pointer ${
                                    expandedRow === idx ? "border-none" : ""
                                  } ${idx % 2 === 0 ? "" : "!bg-[#FBFCFD]"}`}
                                  onClick={() => {
                                    toggleRow(idx);
                                    setSelectedSessionToken(item.session_token);
                                    handleLgbrDataClick(
                                      item.date,
                                      item.session
                                    );
                                  }}
                                >
                                  <td className="py-3 px-4 text-center cursor-pointer">
                                    {expandedRow === idx ? (
                                      <ChevronUp
                                        size={20}
                                        className="text-[#F1935C]"
                                      />
                                    ) : (
                                      <ChevronDown
                                        size={20}
                                        className="text-[#F1935C]"
                                      />
                                    )}
                                  </td>
                                  <td
                                    className={`py-3 px-4 text-center whitespace-normal ${
                                      expandedRow === idx
                                        ? "text-[#525062] font-medium"
                                        : ""
                                    }`}
                                  >
                                    {item.title ? item.title : "-"}
                                  </td>
                                  <td
                                    className={`py-3 px-4 text-center whitespace-normal  truncate max-w-[180px] ${
                                      expandedRow === idx
                                        ? "text-[#525062] font-medium"
                                        : ""
                                    }`}
                                  >
                                    {item.session_token
                                      ? item.session_token
                                      : "-"}
                                  </td>
                                  <td
                                    className={`py-3 px-4 text-center whitespace-normal ${
                                      expandedRow === idx
                                        ? "text-[#525062] font-medium"
                                        : ""
                                    }`}
                                  >
                                    {item.date
                                      ? item.date.split("-").reverse().join("-")
                                      : "-"}
                                  </td>
                                  <td
                                    className={`py-3 px-4 text-center whitespace-normal ${
                                      expandedRow === idx
                                        ? "text-[#525062] font-medium"
                                        : ""
                                    }`}
                                  >
                                    {item.created_date
                                      ? item.created_date
                                          .split("-")
                                          .reverse()
                                          .join("-")
                                      : "-"}
                                  </td>
                                  <td
                                    className={`py-3 px-4 text-center whitespace-normal ${
                                      expandedRow === idx
                                        ? "text-[#525062] font-medium"
                                        : ""
                                    }`}
                                  >
                                    {item.created_time
                                      ? item.created_time
                                      : "-"}
                                  </td>
                                  <td
                                    className={`py-3 px-4 text-center ${
                                      expandedRow === idx
                                        ? "text-[#525062] font-medium"
                                        : ""
                                    }`}
                                  >
                                    <div className="flex items-center justify-center gap-4">
                                      {["Load", "Generation", "Mod", "Bid"].map(
                                        (stageName, i) => {
                                          const status = getStageStatus(
                                            item.stage || "",
                                            stageName
                                          );
                                          const icon = getStageIcon(status);
                                          const iconColor =
                                            getStageIconColor(status);

                                          return (
                                            <div
                                              key={i}
                                              className="flex items-center gap-2"
                                            >
                                              <span
                                                className={`${
                                                  expandedRow === idx
                                                    ? "text-[#525062] font-medium"
                                                    : "font-medium"
                                                } whitespace-nowrap ${
                                                  status !== "inactive"
                                                    ? "text-[#F1935C]"
                                                    : "text-[#C5C5CBD9]"
                                                }`}
                                              >
                                                {stageName}
                                              </span>
                                              <div className="relative group">
                                                <div
                                                  className={`w-4 h-4 rounded-full ${getStageColor(
                                                    status
                                                  )} flex items-center justify-center ${iconColor} text-xs font-bold`}
                                                >
                                                  {icon}
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                    </div>
                                  </td>
                                  <td
                                    className={`py-3 px-4 text-center whitespace-normal`}
                                  >
                                    <button
                                      onClick={() => {
                                        GotoActiveSession(
                                          item.stage,
                                          item.date,
                                          item.session,
                                          item.session_token
                                        );
                                      }}
                                      className={` ${
                                        expandedRow === idx
                                          ? "text-[#525062] font-medium"
                                          : "font-medium"
                                      } flex gap-2 justify-center cursor-pointer items-center mx-auto ${
                                        item.is_active
                                          ? "text-[#F1935C]"
                                          : "text-[#34656D]"
                                      }`}
                                    >
                                      <span>
                                        {item.is_active
                                          ? "Ongoing"
                                          : item.stage === "BID"
                                          ? "Completed"
                                          : "View"}
                                      </span>
                                      <SquareArrow className="w-4 h-4" />
                                    </button>
                                  </td>
                                </tr>
                                {expandedRow === idx && (
                                  <tr className="">
                                    <td colSpan={8} className="bg-gray-50 p-0">
                                      <div
                                        className="overflow-auto capitalize text-nowrap !border !border-[#F1935C] rounded-xl"
                                        style={{
                                          maxHeight: "calc(100vh - 500px)",
                                        }}
                                      >
                                        <table id="my-table_load" className="">
                                          <thead className="sticky top-0 z-10">
                                            <tr className="text-sm !rounded-none">
                                              <HeaderCell2 title="Time Block" />
                                              <HeaderCell2 title="Total Capacity (MW)" />
                                              <HeaderCell2 title="Must Run (MW)" />
                                              <HeaderCell2 title="Surrendable Power (MW)" />
                                              <HeaderCell2 title="Demand (MW)" />
                                              <HeaderCell2 title="Surplus/Deficit (MW)" />
                                            </tr>
                                          </thead>
                                          <tbody className="text-[#8C8A96] font-normal text-[13px]">
                                            {loadingLgbr ? (
                                              <tr>
                                                <td
                                                  colSpan={100}
                                                  className="text-center py-4"
                                                >
                                                  <img
                                                    src={loader}
                                                    width={200}
                                                    alt="loader"
                                                    className="mx-auto"
                                                  />
                                                </td>
                                              </tr>
                                            ) : filterLgbrData.length > 0 ? (
                                              filterLgbrData.map(
                                                (item, idx) => (
                                                  <tr
                                                    key={idx}
                                                    className={` text-center [&>td]:border-none ${
                                                      idx % 2 === 0
                                                        ? "bg-white"
                                                        : "!bg-[#FBFCFD]"
                                                    }`}
                                                  >
                                                    <td className="py-3 px-4 text-center whitespace-normal max-w-[200px]">
                                                      {item.time_slot
                                                        ? item.time_slot
                                                        : "-"}
                                                    </td>

                                                    <td
                                                      className="py-3 px-4 text-center whitespace-normal max-w-[200px] cursor-pointer hover:bg-gray-100 transition-colors"
                                                      onClick={() => {
                                                        setModalOpen(true);
                                                        handleColumnClick(
                                                          "total_generation",
                                                          item.time_slot
                                                        );
                                                      }}
                                                    >
                                                      <span className="underline decoration-dotted">
                                                        {item.total_generation
                                                          ? item.total_generation.toFixed(
                                                              2
                                                            )
                                                          : "-"}
                                                      </span>
                                                    </td>

                                                    <td
                                                      className="py-3 px-4 text-center whitespace-normal max-w-[200px] cursor-pointer hover:bg-gray-100 transition-colors"
                                                      onClick={() => {
                                                        setModalOpen(true);
                                                        handleColumnClick(
                                                          "total_must_run",
                                                          item.time_slot
                                                        );
                                                      }}
                                                    >
                                                      <span className="underline decoration-dotted">
                                                        {item.total_must_run
                                                          ? item.total_must_run.toFixed(
                                                              2
                                                            )
                                                          : "-"}
                                                      </span>
                                                    </td>

                                                    <td
                                                      className="py-3 px-4 text-center whitespace-normal max-w-[200px] cursor-pointer hover:bg-gray-100 transition-colors"
                                                      onClick={() => {
                                                        setModalOpen(true);
                                                        handleColumnClick(
                                                          "total_available",
                                                          item.time_slot
                                                        );
                                                      }}
                                                    >
                                                      <span className="underline decoration-dotted">
                                                        {item.total_available
                                                          ? item.total_available.toFixed(
                                                              2
                                                            )
                                                          : "-"}
                                                      </span>
                                                    </td>

                                                    <td className="py-3 px-4 text-center whitespace-normal max-w-[200px] ">
                                                      {item.demand_mw
                                                        ? item.demand_mw.toFixed(
                                                            2
                                                          )
                                                        : "-"}
                                                    </td>

                                                    <td className="py-3 px-4 text-center whitespace-normal max-w-[200px]">
                                                      {item.surplus_deficit
                                                        ? item.surplus_deficit.toFixed(
                                                            2
                                                          )
                                                        : "-"}
                                                    </td>
                                                  </tr>
                                                )
                                              )
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan={6}
                                                  className=" text-center"
                                                >
                                                  <h1 className="chartHeading !text-base text-center !font-medium w-full">
                                                    No LGBR Data Available...
                                                  </h1>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))}
                          </tbody>
                        </table>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
            <Modal isOpen={isModalOpen} onClose={() => setModalOpen(false)}>
              <div className="w-full">
                <div className="h-[calc(-200px+100vh)]">
                  <div className="w-full h-full flex flex-col gap-4">
                    <div
                      className="gas-chart-container"
                      style={{
                        height: "calc(-60px + 100vh)",
                        borderRadius: "0px!important",
                      }}
                    >
                      <div className="flex justify-between items-center mb-2 border-b border-[#DFEAF2] pb-2">
                        <h2
                          // onClick={handleBackToMain}
                          className="flex justify-around text-sm text-[#34656D] font-medium items-center"
                        >
                          {selectedSessionToken}
                        </h2>

                        <h2 className="chartHeading !text-lg !font-medium">
                          Time Block:
                          {selectedTimeSlot}
                        </h2>
                        <X
                          size={25}
                          className="text-[#A8A29F] cursor-pointer hover:text-gray-600 transition-colors"
                          onClick={(e) => {
                            setModalOpen(false);
                            setDrillDownView(null);
                            setSelectedTimeSlot(null);
                            setDetailedData([]);
                          }}
                        />
                      </div>

                      <div className="overflow-auto capitalize text-nowrap">
                        {loadingLgbrData ? (
                          <div className="h-full w-full bg-white flex items-center justify-center">
                            <img
                              src={loader}
                              width={200}
                              alt="loader"
                              className="block mt-[5rem]"
                            />
                          </div>
                        ) : (
                          <table id="my-table_load">
                            <thead className="sticky top-0 z-10">
                              <tr className="text-sm">
                                <HeaderCell title="Generator Name" />
                                <HeaderCell title={getColumnTitle()} />
                              </tr>
                            </thead>
                            <tbody className="text-[#8C8A96] font-normal text-[13px]">
                              {detailedData.length > 0 ? (
                                detailedData.map((item: any, idx: number) => (
                                  <tr
                                    key={idx}
                                    className="border-b border-gray-200 hover:bg-gray-100 text-center"
                                  >
                                    <td className="py-3 px-4 text-center whitespace-normal max-w-[200px] bg-white !border-r !border-[#F1935C]">
                                      {item.generator || "-"}
                                    </td>
                                    <td className="py-3 px-4 text-center whitespace-normal max-w-[200px] bg-blue-50">
                                      {item.value}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={2}
                                    className="py-8 text-center text-[#8C8A96] w-full"
                                  >
                                    <h1 className="chartHeading !text-base text-center !font-medium w-full">
                                      No LGBR Data Available...
                                    </h1>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        )}
                      </div>
                      <ErrorPopup
                        error={error}
                        onClose={() => setError(null)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
            <ErrorPopup error={error} onClose={() => setError(null)} />
            <div className="gna-footer-container">
              <div className="grid grid-cols-3 justify-between gap-5 ">
                <Tooltip
                  note={<p>IEX DAM and RTM: Daily Market Snapshot</p>}
                  text=" Anticipated Load and Price are Forcasted."
                >
                  <p className="gna-footer-text">Source</p>
                </Tooltip>
                <p className="gna-footer-text col-span-1 text-center">
                  Powered by <strong>GNA Energy</strong>
                </p>
                <strong className="gna-footer-text col-span-1 text-end">
                  Beta Version
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
